import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth';

/** Staff only; a signed-in customer is signed out. Everyone else goes to Login. */
export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const toLogin = inject(Router).createUrlTree(['/login']);

  if (await authService.isStaff()) {
    return true;
  }
  await authService.signOut(); // no-op when nobody is signed in
  return toLogin;
};

/** Login page: staff who are already signed in go straight to the app. */
export const guestGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const toMain = inject(Router).createUrlTree(['/main']);

  return (await authService.isStaff()) ? toMain : true;
};
